import React, { PureComponent } from 'react'
import './GameTemplate.css'

export default class GameTemplate extends PureComponent {
    render() {
        const { className, children } = this.props
        return (
            <div className="wrapper">
                <div className={['Game', className]}>
                    <div className="Game-Board">{children}</div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/templates/GameTemplate.js